// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import helpers from '../util/helpers';

type Props = {
  to: string,
  messageId: string,
  side: string,
  lowPriority?: boolean,
  history: Object
};

type State = {
  enabled: boolean,
}

const NavigationButton = withRouter(class Button extends Component<Props, State> {
  constructor() {
    super();
  }

  onClick(e) {
    e.preventDefault()

    helpers.eventLog("nav:bottom button pressed - " + this.props.messageId + " - " + this.props.to);

    this.props.history.push(this.props.to);
    window.scrollTo(0, 0);

  }

  render() {
    const classes = [
      'button',
      this.props.side,
      this.props.messageId,
      this.props.lowPriority ? 'lowpriority' : '',
      // this.state.enabled ? 'enabled' : 'disabled',
      this.props.page,
    ].join(' ');

    const message = <FormattedMessage id={this.props.messageId} />


    return (
      <a className={classes} onClick={this.onClick.bind(this)}>
        {message}
      </a>
    )
  }
});

export default observer(NavigationButton);



// WEBPACK FOOTER //
// ./src/components/NavigationButton.js